import {
  useMutation,
  useQuery,
  useSubscription,
  useLazyQuery,
} from "@apollo/react-hooks";
import { Button, Card, message, Table } from "antd";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { Loader } from "../../../Components/Loader";
import { CustIcon } from "../../../Components/Svgs";
import {
  CANCEL_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION,
} from "../../../Graphql/mutations";
import {
  GET_CARD_DETAILS,
  GET_CURRENT_SUBSCRIPTIONS,
  GET_PRICE_PACKAGES,
  GET_UPCOMING_INVOICE,
} from "../../../Graphql/queries";
import { GET_USER_SUBSCRIPTION } from "../../../Graphql/subscriptions";
import "./Subscriptions.less";
import CardIconImg from "../../../Assets/Images/card.jpg";
import { ReplaceCardModal } from "../../../Components/Modals/ReplaceCardModal";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PlanUpgradeModal from "../../../Components/Drawers/PlanUpgrade/PlanUpgradeModal";

export const Subscriptions = () => {
  const [showPaymentModel, setShowPaymentModel] = useState(false);
  const [showPlanUpgradeDrawer, setShowPlanUpgradeDrawer] = useState(false);
  const [promise, setPromise] = useState({});
  const [upcomingInvoiceDetails, setUpcomingInvoiceDetails] = useState({});
  const [CANCEL_SUBSCRIPTION_MUTATION, { loading: isCancellingSubscription }] =
    useMutation(CANCEL_SUBSCRIPTION);

  const [UPDATE_SUBSCRIPTION_MUTATION, { loading: isUpdatingSubscription }] =
    useMutation(UPDATE_SUBSCRIPTION);

  const { data: subscriptionData, loading: subscriptionDataLoading } =
    useSubscription(GET_USER_SUBSCRIPTION, {
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
    });

  const { data: pricePackageData } = useQuery(GET_PRICE_PACKAGES, {
    fetchPolicy: "cache-and-network",
  });
  const { data: getCurrentSubscription } = useQuery(GET_CURRENT_SUBSCRIPTIONS, {
    fetchPolicy: "cache-and-network",
  });

  const [
    GET_UPCOMING_INVOICE_DATA,
    { data: upcomingInvoiceData, loading: isLoadingUpcomingInvoiceData },
  ] = useLazyQuery(GET_UPCOMING_INVOICE, {
    fetchPolicy: "cache-and-network",
  });

  const [GET_CARD, { data: cardDetails, loading: cardDetailsLoading }] =
    useLazyQuery(GET_CARD_DETAILS);

  useEffect(() => {
    GET_CARD();
    GET_UPCOMING_INVOICE_DATA();
  }, []);

  useEffect(() => {
    if (upcomingInvoiceData) {
      setUpcomingInvoiceDetails(
        upcomingInvoiceData.get_upcoming_invoice.upcomingInvoice
      );
    }
  }, [upcomingInvoiceData]);

  useEffect(() => {
    if (pricePackageData) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      setPromise(loadStripe(pricePackageData.get_stripe_setup.publishableKey));
    }
  }, [pricePackageData]);

  const reloadUpcomingInvoiceData = () => {
    GET_UPCOMING_INVOICE_DATA();
  };

  // const onUpgradeToYearly = async () => {
  //   const isUpdateSuccessful = await UPDATE_SUBSCRIPTION_MUTATION({
  //     variables: {
  //       price_id: pricePackageData.get_stripe_setup.prices.find(
  //         (p) => p.recurring.interval === "year"
  //       ).id,
  //       locations: subscriptionData?.user_subscription[0]?.locations,
  //       status: "",
  //     },
  //   });
  //   if (!isUpdateSuccessful.errors) {
  //     message.success("Upgrade Requested Successfully!");
  //   } else {
  //     isUpdateSuccessful.errors.forEach((e) => {
  //       return message.error(e.message);
  //     });
  //   }
  // };

  const onUpgradePlan = () => {
    setShowPlanUpgradeDrawer(true);
  };

  const undoCancellationOrUpgrade = (type) => {
    const isCancelUpdateSuccessful = UPDATE_SUBSCRIPTION_MUTATION({
      variables: {
        price_id: subscriptionData?.user_subscription[0].stripe_price_id,
        locations: subscriptionData?.user_subscription[0]?.locations,
        status: type,
      },
    });
    if (!isCancelUpdateSuccessful.errors) {
      message.success("Upgrade Cancellation Requested Successfully!");
      setTimeout(() => {
        reloadUpcomingInvoiceData();
      }, 1000);
      // } else {
      //   message.success("Subscription Resume Requested Successfully!");
      // }
    } else {
      isCancelUpdateSuccessful.errors.forEach((e) => {
        return message.error(e.message);
      });
    }
  };

  const columns = [
    {
      title: "Invoices",
      dataIndex: "invoice_number",
      key: "invoice_number",
    },
    {
      title: "Billing date",
      render: (text, record) => {
        return moment(record.createdAt).format("MM/DD/YYYY");
      },
      key: "billing_date",
    },
    {
      title: "Amount",
      render: (text, record) => {
        return "$" + record.amount_paid.toFixed(2);
      },
      key: "age",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <a
          href={record.invoice_pdf}
          target="_blank"
          rel="noreferrer"
          className="download"
        >
          <CustIcon type="doc-Download" />
        </a>
      ),
    },
  ];

  if (subscriptionDataLoading || cardDetailsLoading) {
    return <Loader />;
  }

  return (
    <div>
      {showPaymentModel && (
        <Elements stripe={promise}>
          <ReplaceCardModal
            customer={
              subscriptionData?.user_subscription[0]?.stripe_customer_id
            }
            location={subscriptionData?.user_subscription[0]?.locations}
            price={subscriptionData?.user_subscription[0]?.stripe_price_id}
            closeModal={() => {
              setShowPaymentModel(false);
              GET_CARD();
            }}
            cardId={cardDetails?.get_payment_methods?.cards[0]?.id}
          />
        </Elements>
      )}
      <div className="secSubTitle pageSubTilte">
        <div className="stLeft">
          <h5 className="">My subscriptions</h5>
        </div>
      </div>
      <Card>
        <Card className="subscriptionCard">
          <div className="subscriptionCardHeader d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <h4>
                {
                  subscriptionData?.user_subscription[0]?.package_price?.package
                    ?.name
                }
                <span>
                  (
                  {
                    subscriptionData?.user_subscription[0]?.subscriptionType
                      ?.description
                  }
                  )
                </span>
              </h4>
              <p>
                {subscriptionData?.user_subscription[0]?.subscriptionStatus
                  ?.status !== "upgrade_applied"
                  ? "Auto Renews"
                  : "Upgrades"}{" "}
                on{" "}
                {moment
                  .unix(
                    getCurrentSubscription?.get_subscriptions.subscriptions
                      .current_period_end
                  )
                  .format("MMMM DD, YYYY")}
              </p>
            </div>
            <div className="d-flex flex-column">
              <div
                className={`status ${subscriptionData?.user_subscription[0]?.subscriptionStatus?.status}`}
              >
                <CustIcon
                  type={
                    subscriptionData?.user_subscription[0]?.subscriptionStatus
                      ?.status
                  }
                />{" "}
                {
                  subscriptionData?.user_subscription[0]?.subscriptionStatus
                    ?.description
                }
              </div>
              <div className="amount">
                $
                {subscriptionData?.user_subscription[0]?.package_price?.price.toFixed(
                  2
                )}
                {/* {subscriptionData?.user_subscription[0]?.subscription_transactions[0]?.amount_paid.toFixed(
                  2
                )} */}
              </div>
            </div>
          </div>
          <div className="subscriptionCardBody">
            <div className="d-flex justify-content-end pt-3">
              <div className="d-flex flex-wrap">
                {!(subscriptionData?.user_subscription[0]?.subscriptionStatus
                      ?.status === "cancel_applied") && upcomingInvoiceDetails?.lines?.data[0]?.plan.id ===
                  subscriptionData?.user_subscription[0].stripe_price_id && (
                  <Button
                    type="default"
                    shape="round"
                    loading={isUpdatingSubscription}
                    onClick={() => onUpgradePlan()}
                    className="exportToCsv mr-2 mb-3"
                  >
                    <CustIcon type="reload" className="mr-2" /> Upgrade Plan
                  </Button>
                )}
                <Button
                  type="default"
                  shape="round"
                  className={` mb-3 ${
                    subscriptionData?.user_subscription[0]?.subscriptionStatus
                      ?.status === "cancel_applied"
                      ? "resumeSubscription "
                      : "cancelRenewal"
                  }
                  `}
                  onClick={
                    subscriptionData?.user_subscription[0]?.subscriptionStatus
                      ?.status === "cancel_applied"
                      ? () => undoCancellationOrUpgrade("resume")
                      : () =>
                          CANCEL_SUBSCRIPTION_MUTATION({
                            onCompleted: () =>
                              message.success(
                                "Subscription Cancellation request sent successfully!"
                              ),
                          })
                  }
                >
                  <CustIcon type="exchange-csv" className="mr-2" />{" "}
                  {subscriptionData?.user_subscription[0]?.subscriptionStatus
                    ?.status === "cancel_applied"
                    ? "Resume Subscription"
                    : subscriptionData?.user_subscription[0]?.subscriptionStatus
                        ?.status === "trial"
                    ? "Cancel Subscription"
                    : "Cancel Subscription"}
                </Button>
              </div>
            </div>
            <Card className="subscriptionTableCard">
              <Table
                rowKey="key"
                columns={columns}
                dataSource={subscriptionData?.user_subscription[0]?.subscription_transactions.map(
                  (row, index) => ({ key: index, ...row })
                )}
              />
            </Card>
          </div>
          {upcomingInvoiceDetails?.lines?.data[0]?.plan.id &&
            upcomingInvoiceDetails?.lines?.data[0]?.plan.id !==
              subscriptionData?.user_subscription[0].stripe_price_id && (
              <div className="subscriptionCardMethod border-bottom">
                <ul className="list-style listOFCards p-0">
                  <li className="d-flex align-items-md-center justify-content-md-between">
                    <div className="cardDetails d-flex align-items-center">
                      <div className="cardImg d-flex align-items-center justify-content-center">
                        <CustIcon type="upgrade_applied" />
                      </div>
                      <div className="cardInfo">
                        <div className="cardType">Upcoming Plan</div>

                        <div className="cardHolderName">
                          {upcomingInvoiceDetails?.lines?.data[0].description}
                        </div>
                        <div className="cardNumber">
                          <div className="num">
                            Effective Date :{" "}
                            {moment
                              .unix(upcomingInvoiceDetails.period_start)
                              .format("MM/DD/YYYY")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>

                <Button
                  type="default"
                  shape="round"
                  size="large"
                  loading={isUpdatingSubscription}
                  onClick={() => undoCancellationOrUpgrade("cancel_upgrade")}
                  className="cancelRenewal mr-2"
                >
                  <CustIcon type="reload" className="mr-2" /> Cancel Upgrade
                </Button>
              </div>
            )}
          {cardDetails && (
            <div className="subscriptionCardMethod">
              <ul className="list-style listOFCards p-0">
                <li className="d-flex align-items-md-center justify-content-md-between">
                  <div className="cardDetails d-flex align-items-center">
                    <div className="cardImg">
                      <img src={CardIconImg} alt="" />
                    </div>
                    <div className="cardInfo">
                      <div className="cardType">
                        {cardDetails?.get_payment_methods?.cards[0]?.card
                          ?.funding === "credit"
                          ? "Credit card"
                          : "Debit Card"}
                      </div>
                      <div className="cardNumber">
                        <div className="dot">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <div className="dot">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <div className="dot">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <div className="num">
                          {
                            cardDetails?.get_payment_methods?.cards[0]?.card
                              ?.last4
                          }
                        </div>
                      </div>
                      <div className="cardHolderName">
                        {
                          cardDetails?.get_payment_methods?.cards[0]
                            ?.billing_details?.name
                        }
                      </div>
                    </div>
                  </div>
                  {/* <Link to="">Change payment method</Link> */}
                </li>
              </ul>

              <Button
                type="secondary"
                shape="round"
                size="large"
                htmlType="submit"
                className="secondary-btn"
                onClick={() => setShowPaymentModel(true)}
              >
                Replace existing card
              </Button>
            </div>
          )}
        </Card>
      </Card>
      {showPlanUpgradeDrawer && (
        <PlanUpgradeModal
          showPlanUpgradeDrawer={showPlanUpgradeDrawer}
          setShowPlanUpgradeDrawer={setShowPlanUpgradeDrawer}
          subscriptionData={
            getCurrentSubscription?.get_subscriptions.subscriptions.items.data[0]
          }
          reloadUpcomingInvoiceData={reloadUpcomingInvoiceData}
          pricePackageData={pricePackageData}
        />
      )}
    </div>
  );
};
